module.exports = __webpack_public_path__ + "img/Structures-2.4f25d485.png";